import auth0 from "auth0-js";
import { Config } from "./config";
export default class Auth {
	constructor() {
		this.auth0 = new auth0.WebAuth(Config.AuthSettings);
		this.handleAuthentication = this.handleAuthentication.bind(this);
		this.signIn = this.signIn.bind(this);
	}
	signIn() {
		this.auth0.authorize();
	}
	logout() {
		this.auth0.logout();
	}
	handleAuthentication() {
		return new Promise((resolve, reject) => {
			this.auth0.parseHash((err, authResult) => {
				if (err) return;
				if (!authResult || !authResult.accessToken) {
					return;
				}
				this.idToken = authResult.accessToken;

				resolve();
			});
		});
	}
}
